// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1RYTa","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1K5Aa"};